import { datadogRum } from '@datadog/browser-rum';
import { type LDFlagSet, useFlags } from 'launchdarkly-react-client-sdk';
import { Navigate } from 'react-router-dom';

type FeatureFlagProtectedProps = {
  // Essentially because LDFlagSet is merged with original declaration which is
  // export interface LDFlagSet {
  //   [key: string]: LDFlagValue;
  // }
  // flagName can still be pretty much anything. Issue is tracked here
  // https://github.com/launchdarkly/js-sdk-common/issues/32
  // TODO: fix this here once issue is resolved.
  flagName: keyof LDFlagSet;
  children: React.ReactElement;
};

export default function FeatureFlagProtected({
  children,
  flagName,
}: FeatureFlagProtectedProps) {
  const flags = useFlags();

  const flagValue = flags[flagName];

  if (typeof flagValue !== 'boolean') {
    datadogRum.addError(
      new Error(
        `Flag ${flagName} is not a boolean. Flag value: ${flagValue}. Error occurred in FeatureFlagProtected component.`
      )
    );
    return <Navigate to="/" />;
  }

  if (!flagValue) {
    return <Navigate to="/" />;
  }

  return children;
}
